/**
 * Below this width Now UI turns the sidebar into a slide-out menu.
 */
export const SLIDE_OUT_SIDEBAR_QUERY = '(max-width: 991px)';

/**
 * Closes the slide-out sidebar menu. Now UI keeps its open state as classes on
 * <html> and the header's toggle button, not in React state.
 */
export function closeSlideOutSidebar(
  toggleButton = document.querySelector('.navbar-toggle .navbar-toggler')
) {
  document.documentElement.classList.remove('nav-open');
  toggleButton?.classList.remove('toggled');
}
